import "babel-polyfill";
import "./libs/slick"
import "./libs/infiniteslidev2"
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import { binder } from "./libs/binder";
import { constants } from "./modules/module";
import { fullHeightPage } from "./modules/fullHeightPage";
import { stickyHeader } from "./modules/stickyHeader";
import { mobileNav } from "./modules/mobileNav";
import { headerPartnersSlider } from "./modules/headerPartnersSlider";
import { hideEventBlock } from "./modules/hideEventBlock";
import { logosSlider } from "./modules/logosSlider";
import { testimonialsSlider } from "./modules/testimonialsSlider";
import { resourcesSlider } from "./modules/resourcesSlider";
import { accordion } from "./modules/accordion";
import { accordionKMDG } from "./modules/accordion";
import { stickyToc } from "./modules/accordion";
import { integrationsSlider } from "./modules/integrationsSlider";
import { animationOnScroll } from "./modules/animationOnScroll";
import { imagesSlider } from "./modules/imagesSlider";
import { customSelect } from "./modules/customSelect";
import { videoFunction } from "./modules/videoFunction";
import { customerStorySlider } from "./modules/customerStorySlider";
import { popups } from "./modules/popups";
import { tabs } from "./modules/tabs";
import { goToAnchor } from "./modules/goToAnchor";
import { commentsSlider } from "./modules/commentsSlider";
import { picturesSlider } from "./modules/picturesSlider";
import { hoverTeamCard } from "./modules/hoverTeamCard";
import { Tickers } from "./modules/tickers";
import {showComparePlansTable} from "./modules/showComparePlansTable";
import {showMorePlans} from "./modules/showMorePlans";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {resetFormFilters} from "./modules/resetFormFilters";
import {equalizeComponentHeights} from "./modules/equalizeHeights";
import {scrollTo} from "./modules/scrollToHash";


binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": [stickyHeader, mobileNav, headerPartnersSlider],
        ".view-all-table": showComparePlansTable,
        ".pricing-plan": showMorePlans,
        ".event-block": hideEventBlock,
        ".logos-slider": logosSlider,
        ".testimonials-slider": testimonialsSlider,
        ".resources-list": resourcesSlider,
        ".accordion": accordion,
        ".single_accordion": accordionKMDG,
        ".wp-block-yoast-seo-table-of-contents": stickyToc,
        ".integrations-sliders": integrationsSlider,
        ".has-animation": animationOnScroll,
        ".images-slider": imagesSlider,
        "select": customSelect,
        ".video": videoFunction,
        ".customer-story-slider": customerStorySlider,
        ".popup-link": popups,
        ".tabs-holder": tabs,
        "[data-goto-anchor]": goToAnchor,
        "[data-scroll]": scrollTo,
        ".comments-slider": commentsSlider,
        ".pistures-slider": picturesSlider,
        ".team-listing": hoverTeamCard,
        ".marquee": Tickers,
        ".copied-link": copyLinkToBuffer,
        ".clear-filters-button": resetFormFilters,
        ".flexibleLayouts": equalizeComponentHeights
    },
    runTests: false
});

window.initCustomSelect = function () {
    customSelect();
};


// WEBPACK FOOTER //
// ./assets/js/global.js